/** This page will display all of the Community's feed items such as
 *  Events, Stories, Collections, and CTAs.
 */

import { GetStaticPaths, GetStaticProps } from "next";
import { generateStaticCommunitySlugPaths } from "@dreambigger/communities/src/utils/static-paths-helper";
import CommunityFeedPage, {
  getCommunityFeedStaticProps,
} from "@dreambigger/communities/src/components/views/community-feed";

// Get the static paths for each community that we want to prerender.
export const getStaticPaths: GetStaticPaths = generateStaticCommunitySlugPaths;

// Get data to statically generate the page for each community.
export const getStaticProps: GetStaticProps = getCommunityFeedStaticProps;

export default CommunityFeedPage;
